import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Container,
  Typography,
} from "@mui/material";
import React from "react";
import CustomButton from "../CustomButton";
import { ChevronRightRounded } from "@mui/icons-material";
import { bethany, bridget, kim, sibo, thamu } from "../../assets/images";

const TeamSection = () => {
  const teamInfo = [
    {
      id: 1,
      img: kim,
      name: "Kimberley Cunninghum",
      role: "CEO",
      quote: "This is a sample quote for each person in the team.",
    },
    {
      id: 2,
      img: bridget,
      name: "Bridget Moyo",
      role: "COO",
      quote: "This is a sample quote for each person in the team.",
    },
    {
      id: 3,
      img: thamu,
      name: "Thamu",
      role: "Product Manager",
      quote: "This is a sample quote for each person in the team.",
    },
    {
      id: 4,
      img: sibo,
      name: "Siboe Sibanda",
      role: "Training & Event Coordinator",
      quote: "This is a sample quote for each person in the team.",
    },
    {
      id: 5,
      img: bethany,
      name: "Bethany Mutangara",
      role: "Volunteer",
      quote: "This is a sample quote for each person in the team.",
    },
  ];

  return (
    <Box
      sx={{
        width: "100vw",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        mb: 10,
        mt: 10,
      }}
    >
      <Container
        sx={{
          display: { xs: "flex", md: "grid" },
          flexDirection: { xs: "column" },
          gridTemplateColumns: { md: "repeat(3, 1fr)" },
          gap: 2.5,
        }}
      >
        <Card sx={{ boxShadow: "none" }}>
          <CardContent sx={{ px: 0 }}>
            <Typography variant="h6">Our Team</Typography>
            <Typography variant="h2" sx={{ mb: 4 }}>
              <span style={{ color: "#DB5430" }}>Meet</span> Our{" "}
              <span style={{ color: "#DB5430" }}>Smart</span> People
            </Typography>
            <Typography variant="body1">
              Behind every great idea is a team of brilliant minds. Our experts
              bring together innovation, experience, and passion to drive
              success. Get to know the people who make it all happen! Together,
              we push boundaries and turn ideas into reality
            </Typography>
          </CardContent>
          <CustomButton sx={{ my: "1rem" }}>
            <Typography>See whole team</Typography>
            <ChevronRightRounded />
          </CustomButton>
        </Card>
        {teamInfo.map((team) => (
          <Card key={team.id} sx={{ boxShadow: "none" }}>
            <CardMedia
              component="img"
              src={team.img}
              sx={{ width: "400px", height: "400px" }}
            />
            <CardContent sx={{ px: 0 }}>
              <Typography variant="h6">{team.name}</Typography>
              <Typography
                variant="h8"
                color="primary.main"
                sx={{ textTransform: "none" }}
              >
                {team.role}
              </Typography>
            </CardContent>
          </Card>
        ))}
      </Container>
    </Box>
  );
};

export default TeamSection;
